import type {ThemeType, ThemeConfig} from '../Theme';
import baseTheme from '../Theme';

export default function ThemeLight(config: ThemeConfig): ThemeType {
    return {
        ...baseTheme(config),
        isDark: false
    };
}
